import { render, staticRenderFns } from "./WebMyFamousPediaPop.vue?vue&type=template&id=6091c9e7&"
import script from "./WebMyFamousPediaPop.vue?vue&type=script&lang=js&"
export * from "./WebMyFamousPediaPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports